import React, { useState } from 'react';
import styled from 'styled-components';
import LoginButton from './LoginButton';

function Welcome({className}) {
  return (
    <center className={className}>        
        <div>
            <img src="/ae-logo.png" alt="logo" width="500px" />
        </div>
        <div>
            <LoginButton label="Advisor Login"/>
        </div>
    </center>
  );
}

export default styled(Welcome)`
padding: 20% !important;
font-family: "Roboto", sans-serif;
.button {
    background: white !important;
    padding: 15px !important;
    width: 180px !important;
    border-radius: 20px !important;
    border: 2px solid #74930c !important;
}

.button:hover {
    background: #74930c !important;
    color: white !important;
}

`;